import { Translator } from '@itarget/shared'

export const useTranslation = () => ({
  videoPresentationExclusive: Translator({ transRef: 'translation.Conteúdo restrito para usuários inscritos' }).props.children,
  inProgress: Translator({ transRef: 'translation.Conteúdo em desenvolvimento' }).props.children,
})
